import { render, staticRenderFns } from "./New2048Game.vue?vue&type=template&id=0d22fc7c"
import script from "./New2048Game.vue?vue&type=script&lang=js"
export * from "./New2048Game.vue?vue&type=script&lang=js"
import style0 from "./New2048Game.vue?vue&type=style&index=0&id=0d22fc7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports